<script lang="ts">
  import { Button, Input, InputGroup } from "sveltestrap";
  import {modalIsopen,viewModalProduct} from "../../../../store";
  import { AddtoCart, Quantity, ViewDetails } from "../../../../utils/Constant/Constant";
  import {handleCart} from "../../../../Data/Ecommerce/Cartdata"
  let setViewproduct:any
  viewModalProduct.subscribe((value)=>{
    setViewproduct = value
  })
  let quantity:number = 1
  //  for quantity minus
  const handleMinusQuantity = () => {
    if(quantity > 1){
        quantity -= 1
    }
  }
  //  for quantity add
  const handlePlusQuantity = () => {
    quantity += 1
  }
  const handleQuntity = (e:any) => {
    quantity = e 
  }
  // for add to cart
  const addModalCart = (product:any,qty:number) => {
    handleCart(product,qty)
    modalIsopen.update((value)=> value = false)
  }
</script>
<div class="product-qnty">
    <h6 class="f-w-600">{Quantity}</h6>
    <fieldset class="qty-box">
      <InputGroup>
        <Button color="primary" on:click={handleMinusQuantity}>-</Button>
        <Input class="touchspin text-center" type="text" value = {quantity} on:change={(e) => handleQuntity(e.target.value)} />
        <Button color="primary" on:click={handlePlusQuantity}>+</Button>
      </InputGroup>
    </fieldset>
    <div class="addcart-btn">
        <Button color="primary" href="/ecommerce/cart" on:click={()=>addModalCart(setViewproduct,quantity)}>{AddtoCart}</Button>
        <Button color="primary" class="ms-2" href="/ecommerce/productpage" >{ViewDetails}</Button>
    </div> 
</div>